import { render, staticRenderFns } from "./WarningRightWitchEditorExample.vue?vue&type=template&id=5424b1ed&scoped=true&"
import script from "./WarningRightWitchEditorExample.vue?vue&type=script&lang=js&"
export * from "./WarningRightWitchEditorExample.vue?vue&type=script&lang=js&"
import style0 from "./WarningRightWitchEditorExample.vue?vue&type=style&index=0&id=5424b1ed&scoped=true&lang=scss&"
import style1 from "./WarningRightWitchEditorExample.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424b1ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
